import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import Footer from "./Components/Footer/Footer";
import Home from "../src/Pages/Home/Home";
import { ToastContainer } from "react-toastify";
import About from "./Pages/About/About";
import Contact from "./Pages/Contact/Contact";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { I18nextProvider } from 'react-i18next';
import i18n from './Components/i18n/i18n';
import { avatar } from "./assets/images";
import SetemDetail from "./Pages/SetemDetail/SetemDetail";
import Services from "./Pages/Services/Services";
import ServicesDetail from "./Pages/ServicesDetail/ServicesDetail";
import Projects from "./Pages/Projects/Projects";
import ProjectDetail from "./Pages/ProjectsDetail/ProjectsDetail";
import Partners from "./Pages/Partners/Partners";
import News from "./Pages/News/News";
import NewsDetail from "./Pages/NewsDetail/NewsDetail";
import axios from "axios";
import AboutLeader from "./Pages/AboutLeader/AboutLeader";
import Header from "./Components/Header/Header";
import LeaderProjectDetail from "./Pages/LeaderProjectDetail/LeaderProjectsDetail";
import Media from "./Pages/Media/Media";

const LanguageWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const location = useLocation(); // Əlavə edildi

  useEffect(() => { 
    const changeLanguage = async () => {
      if (["az", "en", "ru"].includes(lang)) {
        await i18n.changeLanguage(lang);
      } else {
        await i18n.changeLanguage("az");
      }
    };
    
    changeLanguage();
  }, [lang, location.pathname]); // Yalnız lang və pathname'i izlə

  return children;
};
const Layout = () => {
  return (
    <div className="font-firstFont bg-[#F9F9F9]">
      <ToastContainer position="top-right" autoClose={1000} theme="colored" />
     <Header/>
      <Outlet />
      <Footer />
    </div> 
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Navigate to="/az" replace />} />
      
      <Route path="/:lang" element={
        <LanguageWrapper>
          <Layout />
        </LanguageWrapper>
      }>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="about/leader" element={<AboutLeader/>} />
        <Route path="setem/:id" element={<SetemDetail />} />
        <Route path="services" element={<Services />} />
        <Route path="services/:id" element={<ServicesDetail />} /> 
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="leader-projects/:id" element={<LeaderProjectDetail />} />
        <Route path="partners" element={<Partners />} /> 
        <Route path="blogs" element={<News />} />
        <Route path="blogs/:id" element={<NewsDetail />} />
        <Route path="media" element={<Media />} />
        <Route path="contact" element={<Contact />} />
        
      </Route>
    </Route>
  )
);
  

function App() {

    const [settings, setSettings] = useState([]);


    useEffect(() => {
    getProducts(); 
  }, []);

  const getProducts = async () => {
        try {
          const response = await axios.get(
            `https://cortex-site.runasp.net/api/Settings`,
            { withCredentials: false }
          );
          console.log(response.data);
          setSettings(response.data[0]);
        } catch (error) {
          console.error("Error fetching products:", error);
        }
      };


  return (
    <div>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router}>
          <ScrollRestoration />
        </RouterProvider>
      </I18nextProvider>

       <FloatingWhatsApp
          phoneNumber={`+994502186809`}
          accountName="Cortex"
          chatMessage="Salam, sizə necə kömək edə bilərik?"
          placeholder="Mesaj yazın..."
          avatar={avatar}
          messageDelay="1"
        />
    </div>
  );
}

export default App;